const WSRV_BASE = "https://wsrv.nl"
const isDev =
  typeof window !== "undefined" && window.location.hostname === "localhost"

export function optimizedImageUrl(
  url: string,
  width: number,
  quality = 80
): string {
  if (isDev) return url
  // Our blobs already go through Cloudflare Images. Re-proxying them
  // through wsrv.nl re-encodes an already-resized file.
  if (url.includes("assets.petakopi.my") || url.includes("/cdn-cgi/image/")) {
    return url
  }
  return `${WSRV_BASE}/?url=${encodeURIComponent(url)}&w=${width}&output=webp&q=${quality}`
}
